import React from "react";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onPrvsPageChange: (page: number) => void;
  onNextPageChange: (page: number) => void;
  filterArray: any;
  loaderForNext: any;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  onPrvsPageChange,
  onNextPageChange,
  filterArray,
  loaderForNext,
}) => {
  if (totalPages <= 1) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        margin: "15px 0px",
      }}
    >
      <button
        style={{
          padding: "10px",
          backgroundColor: "#fff",
          border: "1px solid rgba(225, 230, 239, 1)",
          borderRadius: "8px",
          width: "50px",
          fontSize: "15px",
          fontWeight: 550,
          color:
            currentPage === 1 ? "rgba(16, 16, 16, 0.3)" : "rgba(63, 68, 77, 1)",
          cursor: currentPage === 1 ? "not-allowed" : "pointer",
        }}
        disabled={currentPage === 1}
        onClick={() => onPrvsPageChange(currentPage - 1)}
      >
        {"<"}
      </button>

      <div
        style={{
          backgroundColor: "rgba(240, 245, 255, 1)",
          border: "1px solid rgba(225, 230, 239, 1)",
          borderRadius: "8px",
          padding: "10px",
          margin: "0px 5px ",
          fontSize: "15px",
          fontWeight: 500,
          width: "50px",
          textAlign: "center",
        }}
      >
        {currentPage}
      </div>

      <button
        style={{
          padding: "10px",
          backgroundColor: "#fff",
          border: "1px solid rgba(225, 230, 239, 1)",
          borderRadius: "8px",
          width: "50px",
          fontSize: "15px",
          fontWeight: 550,
          cursor:
            filterArray?.lastEvaluatedKeyReceived === null ||
            filterArray?.lastEvaluatedKeyReceived === undefined ||
            loaderForNext === true
              ? "not-allowed"
              : "pointer",
          color:
            filterArray?.lastEvaluatedKeyReceived === null ||
            filterArray?.lastEvaluatedKeyReceived === undefined ||
            loaderForNext === true
              ? "rgba(16, 16, 16, 0.3)"
              : "rgba(63, 68, 77, 1)",
        }}
        disabled={
          filterArray?.lastEvaluatedKeyReceived === null ||
          filterArray?.lastEvaluatedKeyReceived === undefined ||
          loaderForNext === true
        }
        onClick={() => onNextPageChange(currentPage + 1)}
      >
        {">"}
      </button>
    </div>
  );
};

export default Pagination;
